import { Dialog, Theme } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARKER_DIALOG_BACKGROUND,
  LIGHT_DIALOG_BORDER_IMAGE_SOURCE,
  PRIMARY_DIALOG_BORDER_IMAGE_SOURCE,
  PRIMARY_DIALOG_BACKGROUND_IMAGE,
  LIGHT_DIALOG_BACKGROUND_IMAGE,
  OFFWHITE_DIALOG_BACKGROUND_IMAGE,
  DARKER_DIALOG_BACKGROUND_IMAGE,
} = COLORS;

const StyledDialog = withStyles((theme: Theme) => ({
  paper: {
    backgroundColor: theme.palette.type === 'dark' ? DARKER_DIALOG_BACKGROUND : 'unset',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderImageSource: `linear-gradient(253deg,   ${PRIMARY_DIALOG_BORDER_IMAGE_SOURCE}, ${LIGHT_DIALOG_BORDER_IMAGE_SOURCE})`,
    borderImageSlice: '1',
    backgroundImage:
      theme.palette.type === 'dark'
        ? `linear-gradient(to bottom, ${DARKER_DIALOG_BACKGROUND_IMAGE}, ${DARKER_DIALOG_BACKGROUND_IMAGE}), linear-gradient(253deg, ${PRIMARY_DIALOG_BACKGROUND_IMAGE}, ${OFFWHITE_DIALOG_BACKGROUND_IMAGE})`
        : `linear-gradient(to bottom, ${LIGHT_DIALOG_BACKGROUND_IMAGE}, ${LIGHT_DIALOG_BACKGROUND_IMAGE}), linear-gradient(253deg, ${PRIMARY_DIALOG_BACKGROUND_IMAGE}, ${OFFWHITE_DIALOG_BACKGROUND_IMAGE})`,
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '8px !important',
  },
}))(Dialog);

export default StyledDialog;
